export default "__VITE_ASSET__4f7fa39e__"